<template>
    <div class="container">
        <v-card>
            <v-card-title class="titulopagina">STOCK DE INSUMOS</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="6" sm="3">
                        <v-select
                            v-model="turno"
                            :items="turnos"
                            item-text="nombre_turno"
                            item-value="id"
                            label="Elija Turno"
                            color="blue darken-3"
                            persistent-hint
                            return-object
                            @change="cargarDatos">
                        </v-select>
                    </v-col>
                    <v-col cols="6" sm="3">
                        <date-picker class="dtpicker" v-model="fecha" @change="cargarDatos" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                        
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-data-table 
            :headers="cabeceras"
            :items="lista"
            class="elevation-1"
            dense
        >
            <template v-slot:item.stock_inicio="prop">
                <v-text-field v-model="prop.item.stock_inicio" @change="save(prop.item)" type="number" outlined dense></v-text-field>
            </template>
            <template v-slot:item.recepcion="prop">
                <v-text-field v-model="prop.item.recepcion" @change="save(prop.item)" type="number" outlined dense></v-text-field>
            </template>
            <template v-slot:item.consumo="prop">
                <v-text-field v-model="prop.item.consumo" @change="save(prop.item)" type="number" outlined dense></v-text-field>
            </template>
            <template v-slot:item.stock_final="prop">
                <v-text-field v-model="prop.item.stock_final" readonly type="number" outlined dense></v-text-field>
            </template>
        </v-data-table>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
// import axios from 'axios'
export default {
    data:()=>({
        turno: [],
        lista:[],
        turnos: [],
        fecha: new Date().toISOString().substr(0, 10),
        mostrar_fecha: false,
        //configuracion para datatable
        cabeceras:[
            {
                text: 'Nombre_del_Insumo_a_ingresar_stock',
                align: 'center',
                sortable: true,
                value: 'insumo',
            },
            {
                text: 'Stock Inicial',
                align: 'center',
                sortable: true,
                value: 'stock_inicio',
            },
            {
                text: 'Recepcion',
                align: 'center',
                sortable: true,
                value: 'recepcion',
            },
            {
                text: 'Consumo',
                align: 'center',
                sortable: true,
                value: 'consumo',
            },
            {
                text: 'Stock Final',
                align: 'center',
                sortable: true,
                value: 'stock_final',
            },
        ],
        acciones:[]
    }),
    mounted() {
        this.cargarTurnos();
    },
    methods: {
        async cargarTurnos(){
            let url = `${this.base_url}turnos`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.turnos = response.data.data;
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async cargarDatos(){
            //this.mostrarLoading('Cargando Datos...');
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}stock_insumos/turno/${this.turno.id}/${this.fecha}`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.lista = response.data.data;
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async save(item){
            item.stock_final = parseInt(item.stock_inicio) + parseInt(item.recepcion) - parseInt(item.consumo);
            if(item.stock_insumo_id > 0){
                let url = `${this.base_url}stock_insumos/${item.stock_insumo_id}`;
                let data = {
                    fecha: this.fecha,
                    turnos_id: this.turno.id,
                    insumos_produccion_id: item.insumos_produccion_id,
                    stock_inicio: item.stock_inicio,
                    recepcion: item.recepcion,
                    consumo: item.consumo,
                    stock_final: item.stock_final,
                    //consumo_aceite: item.consumo_aceite
                };
                //console.log(data); return;
                await this.axios.put(url, data, this.headers).then((response) => {
                    let stock = response.data.data;
                    item.stock_insumo_id = stock.id;
                });
            }else if (item.stock_insumo_id == 0){
                // new
                let url = `${this.base_url}stock_insumos`;
                let data = {
                    fecha: this.fecha,
                    turnos_id: this.turno.id,
                    insumos_produccion_id: item.insumos_produccion_id,
                    stock_inicio: item.stock_inicio,
                    recepcion: item.recepcion,
                    consumo: item.consumo,
                    stock_final: item.stock_final,
                    //consumo_aceite: item.consumo_aceite
                };
                //console.log(data); return;
                await this.axios.post(url, data, this.headers).then((response) => {
                    let stock = response.data.data;
                    item.stock_insumo_id = stock.id;
                });
            }
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers']),

        fecha_formateada () {
          return this.fecha ? this.moment(this.fecha).format('DD-MM-YYYY') : '';
        }
    },
    components:{
        'modal':Modal,
        'data-table':Data_Table,
        DatePicker
    }
}
</script>
<style scoped>
    .mx-datepicker{
        width: 100% !important;
    }
</style>